(function(){
     'use strict';

     angular
        .module('appback')
        .factory('AiService', AiService);

    AiService.$inject = ['$http'];

    function AiService($http){
        var service= {
           getPrompt:getPrompt,
        };

        return service;
        function getPrompt(prompt_id, callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/ai/getprompt', { params : { prompt_id:prompt_id }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }
    }
})();